<template>
  <section class="d-flex flex-column h-full bg-documentGray">
    <!-- <div class="fixed-header w-full"> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      :hideCategory="true"
      staticMode="true"
    ></TopAppBar>


    <div class="flex-grow-1 scroll-y">
    <noticeList></noticeList>
    <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
    </div>

  </section>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import noticeList from '@/components/notice/List'

export default {
    name: 'notice',

    data() {
        return {
            // title
            leftBtnMethod: () => { this.$router.go(-1)}
        }
    },
    components: {
        TopAppBar,
        noticeList
    },

    mixins: [topAppBarMixin],

    watch: {
        '$route' (to, from) {

        }
    },

    mounted() {
        this.setTopAppBarHomeSearch(this.$t('3036'))
    },


}



// Components/Mixin/Extend/API define
// import TopAppBar from "@/components/TopAppBar.vue";
// import { topAppBarMixin } from "@/mixins/topAppBar.js";
// import HelpDeskList from '@/components/helpDesk/List'
// import { MDCTabBar, MDCTabBarFoundation } from "@material/tab-bar";

// export default {
//   name: "learn",

//   data() {
//     return {
//       leftBtnMethod: () => {
//         this.$router.go(-1);
//       },
//       tabBar: null,
//     };
//   },
//   components: {
//     TopAppBar,
    //HelpDeskList,
    // Faq: () => import("@/components/helpDesk/Faq.vue"),
    // Inqueriy: () => import("@/components/helpDesk/Inqueriy.vue"),
//   },

//   mixins: [topAppBarMixin],

//   watch: {
//     $route(to, from) {},
//   },

//   mounted() {
//     $(document).ready(function () {
//       $(".tabs").tabs();
//     });
//     this.tabBar = new MDCTabBar(document.querySelector(".mdc-tab-bar"));
//     this.setTabActive();
//     this.setTopAppBarBackSearch(this.$t("1496"));
//   },

//   methods: {
//     setTabActive() {
//       let status = this.$route.query.status;
//       if (status === "FAQ") {
//         this.tabBar.activateTab(0);
//       } else if (status == "INQUERY") {
//         this.tabBar.activateTab(1);
//       } else {
//         this.tabBar.activateTab(0);
//       }
//     },
//   },
// };
</script>

<style scoped>
.fixed-header {
  position: fixed;
  top: 0;
}
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}

.nav-extended .brand-logo {
  font-size: 20px;
  letter-spacing: -0.6;
}

.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 var(--Shadow1);
            background-color: var(--DocumentWhite);
        }

.tabs .tab {
  width: 50%;
}
.listItems {
  border-bottom: 1px solid var(--Divider);
}
.b-radius2 {
  border-radius: 2px;
}
.l-spacing36 {
  letter-spacing: -0.36px;
}
.font-16 {
  font-size: 16px;
}
.bg-paymentBlue3 {
  background-color: var(--ContentBlue);
}
.queryCount {
  border-radius: 50%;
  line-height: 1.7;
}
.font-11 {
  font-size: 11px !important;
}
#tab1, #tab2{
    margin-top: 112px;
}
</style>
